<template>
  <el-dialog
      :title="title"
      :visible.sync="modelValue"
      :close-on-click-modal="false"
      custom-class="custom-dialog-class"
      @opened="handleOpen"
      append-to-body
      width="30%"
      :before-close="handleClose">
    <template #default >
      <div class="dialog-container" >
        <el-form
            :model="form"
            hide-required-asterisk
            ref="formRef"
            label-width="120px"
            :rules="rules" >
          <el-form-item label="食材名称：" prop="ingredientName">
            <el-input
                v-model="form.ingredientName"
                maxlength="10"
                show-word-limit
                clearable
                placeholder="请输入" />
          </el-form-item>
          <el-form-item label="食材类型：" prop="category">
            <el-select v-model="form.category" clearable placeholder="请选择">
              <el-option v-for="item in dietStandardCategoryList"
                         :key="item.dictKey"
                         :label="item.dictValue" :value="item.dictKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="能量(kcal)：" prop="energy">
            <el-input
                v-model="form.energy"
                v-decimal
                clearable
                placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="蛋白质(g)：" prop="protein">
            <el-input
                v-model="form.protein"
                v-decimal
                clearable
                placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="脂肪(g)：" prop="fat">
            <el-input
                v-model="form.fat"
                v-decimal
                clearable
                placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="碳水化合物(g)：" prop="carbohydrate" class="el-form-item-end" >
            <el-input
                v-model="form.carbohydrate"
                v-decimal
                clearable
                placeholder="请输入"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template #footer >
      <div class="dialog-footer">
        <el-button type="primary" @click="confirm_handler">保 存</el-button>
        <el-button @click="handleClose(cancel_handler)">取 消</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "AddDialog",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: "",
    },
    ingredientName: {
      type: String,
      default: "",
    },
    category: {
      type: [String,Number],
      default: "",
    },
    energy: {
      type: [String,Number],
      default: "",
    },
    protein: {
      type: [String,Number],
      default: "",
    },
    fat: {
      type: [String,Number],
      default: "",
    },
    carbohydrate: {
      type: [String,Number],
      default: "",
    },
  },
  data() {
    return {
      form: {
        ingredientName: "",
        category: "",
        energy: "",
        protein: "",
        fat: "",
        carbohydrate: "",
      },
      rules: {
        ingredientName: [
          { required: true, message: '食材名称不能为空', trigger: 'change' }
        ],
        category: [
          { required: true, message: '请输入数值，不能为空', trigger: 'change' }
        ],
        energy: [
          { required: true, message: '请输入数值，不能为空', trigger: 'change' }
        ],
        protein: [
          { required: true, message: '请输入数值，不能为空', trigger: 'change' }
        ],
        fat: [
          { required: true, message: '请输入数值，不能为空', trigger: 'change' }
        ],
        carbohydrate: [
          { required: true, message: '请输入数值，不能为空', trigger: 'change' }
        ],
      },
      dietStandardCategoryList: [],
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    title() {
      let str = "录入食材";
      if (this.id) {
        str = "编辑食材";
      }
      return str;
    },
  },
  created() {
    this.getDietStandardCategoryList();
  },
  mounted() {

  },
  methods: {
    handleOpen() {
      if (this.id) {
        this.form.ingredientName = this.ingredientName;
        this.form.category = this.category;
        this.form.energy = this.energy;
        this.form.protein = this.protein;
        this.form.fat = this.fat;
        this.form.carbohydrate = this.carbohydrate;
      }
    },
    async getDietStandardCategoryList() {
      try{
        const res = await this.$get(`dictionary/type/${"diet_standard_category"}`);
        if (!res) return false;
        this.dietStandardCategoryList= res.data;
      }catch (e) {
        console.error(`获取食材类型接口失败`, e);
      }
    },
    confirm_handler() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.save_handler();
        } else {
          return false;
        }
      });
    },
    async save_handler() {
      try {
        const res = await this.$post("ingredient/enter", {
          ...this.form,
          id: this.id,
        });
        if (!res) return false;
        this.$emit("updateList");
        this.handleClose(this.cancel_handler);
      }catch (e) {
        console.error(`保存食材接口失败`, e);
      }
    },
    cancel_handler() {
      this.modelValue = false;
    },
    handleClose(done) {
      this.$refs.formRef.resetFields();
      done();
    },
  }
}
</script>


<style scoped lang="scss">
.dialog-container{
  width: 400px;
  margin: 0 auto;
}
</style>
